<!-- <div class="camera-overlay" *ngIf="cameraWork">
	<div class="camera-corners">

	</div>
</div> -->

<!-- <div [hidden]="!barcodeValue">
	{{ barcodeValue }}
</div> -->

<zxing-scanner [formats]="[4, 11]" (camerasFound)="camerasFound()"
	(scanSuccess)="scanSuccess($event)">

</zxing-scanner>

<div class="scan-overlay">
	<div class="scan-block" [ngClass]="{'scan-now': isScanning}"></div>
</div>